import React from 'react';
import { approachPillars } from '../../data/mock';

export default function Approach() {
  return (
    <section className="py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div>
            <div className="uppercase tracking-widest text-splash-coral text-xs font-semibold mb-3">Our Method</div>
            <h2 className="font-display font-bold text-4xl md:text-5xl text-splash-green max-w-xl leading-tight">The Little Splash Approach</h2>
          </div>
          <p className="max-w-md text-splash-green/75">Every element of our program is designed to help children feel safe, focused, and successful — from class size to pool environment.</p>
        </div>
        <div className="grid md:grid-cols-3 gap-6">
          {approachPillars.map((p) => (
            <div key={p.title} className="bg-white rounded-3xl p-8 border border-splash-sand card-hover text-center md:text-left">
              <h3 className="font-display text-2xl font-bold text-splash-green mb-3">{p.title}</h3>
              <p className="text-splash-green/75 leading-relaxed">{p.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
